import { render, staticRenderFns } from "./SoundThumbnail.vue?vue&type=template&id=24cfed6c&scoped=true&"
import script from "./SoundThumbnail.vue?vue&type=script&lang=ts&"
export * from "./SoundThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./SoundThumbnail.vue?vue&type=style&index=0&id=24cfed6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cfed6c",
  null
  
)

export default component.exports